<template>
  <div class="header">
    <img src="../assets/imgs/join_header.png" alt="" />
  </div>
  <div class="jobs">
    <div class="title">招聘岗位</div>
    <div class="wrap">
      <div
        class="job"
        v-for="(item, index) of jobList"
        :key="index"
        @click="gotoDetailPage(item)"
      >
        <div class="title">
          {{ item.name }}
        </div>
        <div class="sub_title">{{ item.education }} | {{ item.work_year }}</div>
        <div class="descript">
          <div v-for="(p, ind) of item.description" :key="ind">
            {{ ind + 1 }}：{{ p }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { ref } from "@vue/reactivity";
import { useRouter } from "vue-router";
import { onMounted } from "@vue/runtime-core";
import { getEmploymentList } from "@/api/http";
export default {
  components: {},
  setup() {
    const jobList = ref<any>([]);
    const router = useRouter();
    const gotoDetailPage = (job: any) => {
      localStorage.jobDetail = JSON.stringify(job);
      router.push("/joinDetail");
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      } else {
        document.body.scrollTop = 0;
      }
    };
    onMounted(() => {
      getEmploymentList().then((data) => {
        if (data.code === "0") {
          jobList.value = data.data;
        }
      });
    });
    return {
      jobList,
      gotoDetailPage,
    };
  },
};
</script>
<style lang="less" scoped>
.header {
  width: 1200px;
  margin: 0 auto;
  font-size: 0px;
  img {
    width: 1920px;
    margin-left: -360px;
  }
}
.jobs {
  padding-bottom: 52px;
  > .title {
    width: 1200px;
    margin: 0 auto;
    padding-top: 84px;
    font-size: 32px;
    color: #2c2d3f;
    font-weight: bold;
  }
  .wrap {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    .job {
      background: #fff;
      width: 518px;
      padding: 30px;
      height: 120px;
      margin-top: 40px;
      cursor: pointer;
      border-radius: 4px;
      .title {
        font-size: 20px;
        color: #2c2d3f;
        font-weight: bold;
      }
      .sub_title {
        font-size: 16px;
        color: #596675;
        margin-top: 10px;
      }
      .descript {
        margin-top: 12px;
        white-space: pre-line;
        color: #8392a5;
        font-size: 15px;
        line-height: 24px;
        height: 46px;
        overflow: hidden;
      }
      &:hover {
        box-shadow: 0 0 16px 1px #e6ebed;
      }
    }
  }
}
</style>